require('property/form-search');


// Fix le "load from bs cache" for iOs
/*$(window).bind("pageshow", function(event) {
    if (event.originalEvent.persisted) {
        window.location.reload() 
    }
});*/

// Fix le "load from bs cache" for iOs
var iOS = !!navigator.platform && /iPad|iPhone|iPod/.test(navigator.platform);
if(iOS){
    $(window).bind("pageshow", function(event) {
        if (event.originalEvent.persisted) {
           // window.location.reload()
           $(".input-location select").select2("refresh");
        }
    });
}


// Fixe la hauteur du l'icone de fermeture
function heightEngineAside(){
    var heightNav = $('.nav').outerHeight(), heightEngine = $('.search-container').outerHeight();


    if (window.matchMedia("(min-width: 992px)").matches) {
      /* La largeur minimum de l'affichage est 992px inclus */

      if ($('header').hasClass('scrolled')) {
        $('.sblk.search-int .engine-aside-search').css({
            'top': 73,
            'height': heightEngine-11
        });
    } else {
        /* Bug on IE */
        /*$('.sblk.search-int .engine-aside-search').css({
            'top': heightNav+10,
            'height': heightEngine-10
        });*/
    }
        // Si la largeur est inférieure à 992px
    } else {
        if ($('header').hasClass('scrolled')) {
            $('.sblk.search-int .engine-aside-search').css({
                'top': heightNav,
                'height': heightEngine
            });
        } else {
            $('.sblk.search-int .engine-aside-search').css({
                'top': heightNav,
                'height': heightEngine-5
            });
        }
    }
};

// fixe la position de la search engine
function positionSearchEngine(){
    var heightEngine = $('.nav.scrolled').outerHeight();

    if ($(window).scrollTop() > $('.nav.scrolled').outerHeight()) {
      //$('.search-container').css('position', 'fixed');
      if ($('.search-effect').hasClass('active')) {
            $('.band-header').css('padding-top', heightEngine );
        }
    } else {
          //$('.search-container').css('position', 'relative');
          $('.band-header').css('padding-top', 0 );
      }
};

function open(_animation) {
    if (_animation) {
        $('.search-effect').animate({ 'opacity': 1}, { queue: true, duration: '500'}).animate({ 'width': 'toggle', 'height': 'toggle'}, '400', function() {
            /* stuff to do after animation is complete */
            if ($('body').hasClass('buy-search')) {
                $('.buy-search .list-prop').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');$('.buy-search-parameters .list-prop').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
                $('.no-results').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
            }
            else if ($('body').hasClass('buy-search-parameters')) {
                $('.buy-search-parameters .list-prop').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
            }
        });

        $('span','.engine-aside-search').delay(300).slideDown();
        $('.aside-nav-icon-engine').delay(300).slideDown();
        $('.sblk.search-int').delay(400).fadeTo('fast', 1);
        $('.aside').css('bottom', -($('.aside').outerHeight() - $('.aside-nav-a').outerHeight()) );       
        setTimeout(function () {
            if ($('.fxlat').length) {
                navHeight = $('.nav').height() + $('.search-container').height() - 10;
                $('.fxlat').css('top', navHeight + 'px');
            }
        }, 1000)
    } else {
        $('.search-effect').css({
            'opacity': 1,
            'display': ''
        });
        $('.aside').css('bottom', -($('.aside').outerHeight() - $('.aside-nav-a').outerHeight()) );
        if ($('.fxlat').length) {
            navHeight = $('.nav').height() + $('.search-container').height() - 10;
            $('.fxlat').css('top', navHeight + 'px');
        }
    }
}



function close(_animation) {
    if (_animation) {
        $('.sblk.search-int').delay(200).fadeTo('fast', 0);
        $('span','.engine-aside-search').delay(200).slideDown();
        $('.aside-nav-icon-engine').delay(200).slideUp();
        $('.search-effect').animate({ 'opacity': 0}, { queue: true, duration: '500'}).animate({ 'width': 'toggle', 'height': 'toggle'}, 'fast');
        $('.aside').css('bottom', -$('.aside').outerHeight() );

        if ($('body').hasClass('buy-search')) {
           $('.buy-search .list-prop').delay(400).animate({ 'paddingTop': 0}, '500');
           $('.no-results').delay(400).animate({ 'paddingTop': 0}, '500');

       } else if ($('body').hasClass('buy-search-parameters')) {

        $('.buy-search-parameters .list-prop').delay(400).animate({ 'paddingTop': 0}, '500');
    }


        setTimeout(function () {
            
            if ($('.fxlat').length) {
                navHeight = $('.nav').height() + $('.search-container').height() - 10;
                $('.fxlat').css('top', navHeight + 'px');
            }
        }, 1000)
    } else {
        $('.search-effect').css({
            'opacity': 0,
            'display': 'none'
        });
        $('.aside').css('bottom', -$('.aside').outerHeight() );
        if ($('.fxlat').length) {
            navHeight = $('.nav').height() + $('.search-container').height() - 10;
            $('.fxlat').css('top', navHeight + 'px');
        }
    }
}

function paddingListProp(){
    if ($('.search-effect').hasClass('active') && window.matchMedia("(min-width: 992px)").matches) {
        if ( $('.container').hasClass('no-results') ) {
            $('.no-results').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
        } else {
            if ($('body').hasClass('buy-search-parameters')) {
                $('.buy-search-parameters .list-prop').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
            } else {
                $('.buy-search .list-prop').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
            }
        }

        $('#propertySearchOpenSearchBtn').on('click', function() {
            $('.engine-aside-search').css('height', '123px');
            setTimeout(function () {
                if ( $('body').hasClass('buy-search-parameters') ) {
                    $('.buy-search-parameters .list-prop').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
                } else {
                    $('.buy-search .list-prop').animate({ 'paddingTop': $('.search-container').outerHeight()}, '400');
                }
            }, 400)
     });

   }
}

function animateSearch(){

    //Animation search engine
    if ($('.search-effect').hasClass('active')) {
        open(false);
    } else if ($('.search-effect').hasClass('no-active')) {
        close(false);
    }
    // hide engine search screan mode
    if (!$('body').hasClass('home')) {
        $('.engine-aside-search').click(function() {
            close(true);
            $('.search-effect').removeClass('active').addClass('no-active')
        });
    }
    // show engine search screan mode
    if (!$('body').hasClass('home')) {
        $('div.aside-search').click(function() {
            open(true);

            $('.search-effect').addClass('active').removeClass('no-active')
        });
    }
}

function animateSearchTable(){
    var aside = $('.aside'), copyAside = aside.clone(), engine =$('.search-container'), navHeight = $('.nav').outerHeight();

    copyAside.insertAfter(engine);
    aside.remove();

    //Animation search engine
    // hide engine search screan mode
    if (!$('body').hasClass('home')) {
        $('.engine-aside-search').click(function() {
            engine.slideUp(400);
        });
    }
    // show engine search screan mode
    if (!$('body').hasClass('home')) {
        $('div.aside-search').click(function(){
            engine.slideDown(400);
        });
    }
}

function animateSearchMobile(){

    //Animation search engine
    // show engine search screan mode
    if (!$('body').hasClass('home')) {
    // show and hide engine search mobile mode
    $('.mobile-nav-btn-search').click(function() {
        $('.mobile-nav-btn-search').toggleClass('svg-black-mobile');
        $('.search-container').toggleClass('mobile');

        $('.search-effect').css({
            opacity: 1,
            display: 'initial'
        })
    })
    }
}

function stopBodyScrolling (bool) {
    if (bool === true) {
        document.body.addEventListener("touchmove", _preventDefault, false);
    } else {
        document.body.removeEventListener("touchmove", _preventDefault, false);
    }
}
var _preventDefault = function(e) {
    if (!$('.search-container').has($(e.target)).length) e.preventDefault();
};


$(document).ready(function(){    var locationAlreadySelected = $('#location').val();
    var skipLocationLoadFromCookie = false;
    if(locationAlreadySelected && locationAlreadySelected.length > 0){
        var skipLocationLoadFromCookie = true;
    }

    $('#propertySearch').PropertyFormSearch({
        typeTransactionSelector             : '#typeTransaction',
        typeSelectSelector                  : '#typeSelect',
        locationSelector                    : '#location',
        alertContainerSelector              : '#propertySearchAlertContainer',
        moreOptionsBtnSelector              : '#propertySearchOpenSearchBtn',
        advancedOptionsContainerSelector    : '#propertyFormAdvancedSearch',
        advancedOptionsInputSelector        : '.search-group',
        moreOptionsBtnActivatedHtml         : '<i class="fa fa-minus"></i>',
        moreOptionsBtnUnactivatedHtml       : '<i class="fa fa-plus"></i>',
        skipLocationValidation              : false,
        skipLocationLoadFromCookie          : skipLocationLoadFromCookie,
        onSubmit                            : null,
        typeBienCallback                    : function(){
            var closestPropTypes = $(this).closest('.prop-types');
            var input = $('.select2-search__field',closestPropTypes);
            var placeHolder = $(this).data('placeholder');
            if(!placeHolder){
                placeHolder = 'Type de bien';
            }
            input.attr('placeHolder', placeHolder);
            input.attr('id', 'noKbd');
        },
        locationCallback                    : function(){
            var closestPropTypes = $(this).closest('.input-location');
            var input = $('.select2-search__field', closestPropTypes);
            var placeHolder = $(this).data('placeholder');
            if(!placeHolder){
                placeHolder = 'Lieu';
            }

            setTimeout(
                function(){
                    input.attr('placeHolder', placeHolder);
                },
                100
            );
        },
    });

    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
        
        $("#noKbd").attr("readonly", true);


        /* Disable zoom on forms */
        $(".sblk select").parent().find("input").on('focus', function(){
          // replace CSS font-size with 16px to disable auto zoom on iOS
          $(this).data('fontSize', $(this).css('font-size')).css('font-size', '16px');
        }).on('blur', function(){
          $(this).css('font-size', $(this).data('fontSize'));
        });

        /* Disable input on iOs select */
        var selects_no_keyboard = $("select#piecesSelect, select#alertBuyFormTypeSelect, select#alertRentFormTypeSelect, select#roomNumbers, select#bedroomNumbers, select#aptNumbers, select#floorNumbers, select#caracteristicsList");
        selects_no_keyboard.parent().find(".select2-container input").hide();

        var selects = $("select#piecesSelect, select#typeSelect, select#roomNumbers, select#bedroomNumbers, select#aptNumbers, select#floorNumbers, select#caracteristicsList");
        if(selects.parent().find(".select2-selection__choice").length){
            selects.parent().find(".select2-container input").addClass("filled");
        }else{
            selects.parent().find(".select2-container input").removeClass("filled");
        }

        selects.on("change",function(e){
            e.preventDefault();
            // If contain data, add a class to hide it on mobile
            if($(this).parent().find(".select2-selection__choice").length){
                //alert("A result exists");
                $(this).parent().find(".select2-container input").addClass("filled");
            }else{
                //alert("NO result exists");
                $(this).parent().find(".select2-container input").removeClass("filled");
            }
        });

        /* Trigger open list on input focus : iOs bug */
        $("select#typeSelect").on('click',function(e){
            $(this).select2('open');
        });

        /* Disable input on iOs select */
        //$("select#location").parent().find("input").attr("type", "number");
        $(".form-group-budgets input, .form-group-budget input").attr("type", "number");
        $("input[name='surfaceMini'], input[name='surfaceMax'], input[name='terrainMini'], input[name='terrainMax']").attr("type", "number");
    }

    /* Trigger clic on input icon */
    $(".input-group-addon").click(function(e){
        $(this).next().select2('open');
    });


    $('#typeTransaction').select2({
        minimumResultsForSearch: -1,//prevent display of input text for search
    });

    // Définition de la hauteur max de la search engine
    var heightMax = $( window ).height()-60;
    $('.search-container').css('maxHeight', heightMax);
    //animation nav
    if (!$('body').hasClass('home')) {
        $('a.mobile-nav-btn-search').click(function() {
            var body = $("html, body");
            if(body.hasClass("search-opened")){
                body.removeClass("search-opened").addClass("search-closed");
                //stopBodyScrolling(false);
            }
            else{
                body.removeClass("search-closed").addClass("search-opened");
                //stopBodyScrolling(true);
            }

            body.stop().animate({scrollTop:0}, '500');
            $('.sblk.search-int').slideDown();
        });
    }

    if (window.matchMedia("(min-width: 992px)").matches) {
        /* La largeur minimum de l'affichage est 992px inclus */
        animateSearch();
    }

    if (window.matchMedia("only screen and (min-width: 768px) and (max-width: 991px)").matches) {
        /* La largeur maximum de l'affichage est 991px inclus */
        animateSearchTable();
    }

    if (window.matchMedia("(max-width: 768px)").matches) {
        /* La largeur maximum de l'affichage est 768px inclus */
        animateSearchMobile();
    }

    heightEngineAside();
    //positionSearchEngine();

    $('#propertySearchOpenSearchBtn').click(function() {
        if($(this).hasClass('activated') ) {
            $('.first.search-btn').hide();
        }else {
           $('.first.search-btn').show();
        }
        heightEngineAside();
   });

     $('#alertBuyFormMoreOptionsBtn').click(function() {
        if($(this).hasClass('activated') ) {
            $('.first-btn').show();

        }else {
           $('.first-btn').hide();
       }
   });

    paddingListProp();

});



$(document).scroll(function() {

 heightEngineAside();
 //positionSearchEngine();

});
